import useQueryData from 'src/queries/useQueryData';
import { userRoleSelector } from 'src/selectors/user';
import { USER_QUERY_KEY } from 'src/constants/query';
import { Roles } from 'src/constants/role';

const featureFlags = {
  legacyClientHealthIssuesModal: true,
  legacyUnknownEnforcementModal: true,
  basePolicyGroupsAdminOnly: true,
  deploymentRingsAdminOnly: true,
  // Deployment toggles and deployment tags only decide how automated deployment would behave, and
  // nothing deploys automatically yet, so they stay out of the way until it does.
  automatedDeploymentSettingsAdminOnly: true,
  // The portfolio lists apps at the version level rather than per customer application. The catalog
  // stays on until it has taken over everything the catalog does, so these two move together.
  appCatalogEnabled: true,
  appPortfolioAdminOnly: true,
  // Updating devices in bulk from an uploaded CSV is still being built out step by step.
  bulkDeviceUpdateEnabled: true,
  // Creating a base policy from the wizard is still experimental, so most users only bring existing
  // ones under management.
  createManagedBasePolicyAdminOnly: true,
};

// A gated view decides both whether it is offered and whether it renders when reached directly, so
// each flag is read through one hook rather than at every place that has to respect it.
const useAdminOnlyFlag = adminOnly => {
  const role = useQueryData(USER_QUERY_KEY, userRoleSelector);
  return !adminOnly || role === Roles.superAdmin;
};

export const useCanViewBasePolicyGroups = () =>
  useAdminOnlyFlag(featureFlags.basePolicyGroupsAdminOnly);

export const useCanViewDeploymentRings = () =>
  useAdminOnlyFlag(featureFlags.deploymentRingsAdminOnly);

export const useCanViewAutomatedDeploymentSettings = () =>
  useAdminOnlyFlag(featureFlags.automatedDeploymentSettingsAdminOnly);

export const useCanViewAppCatalog = () => featureFlags.appCatalogEnabled;

export const useCanViewAppPortfolio = () => useAdminOnlyFlag(featureFlags.appPortfolioAdminOnly);

export const useCanBulkUpdateDevices = () => featureFlags.bulkDeviceUpdateEnabled;

export const useCanCreateManagedBasePolicy = () =>
  useAdminOnlyFlag(featureFlags.createManagedBasePolicyAdminOnly);

export default featureFlags;
